export enum EmbloomGroupCertificate {
    ksyos = 'ksyos',
    mediis = 'mediis',
}
